// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents inobtained
// from Xngage LLC.
//

import { viewStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { color, hideElementOnPrint, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

viewStyles.bottomSection = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 44px;

        ${({ isInShell }: any) => {
            if (!isInShell) {
                return `
                & > div:empty {
                    display: none;
                }`;
            }
        }}
    `,
};

viewStyles.stickyWrapper = {
    css: css`
        position: fixed;
        left: 0;
        background: ${color("common.white")};
        width: 100%;
        z-index: 1300;
        transition: all 300ms ease-out;
        opacity: 1;
        pointer-events: initial;
        height: auto;
        max-height: 107px;
        overflow: hidden;
        box-shadow: 0 1px 0 0 ${color("common.border")};

        &.stickyVisible {
            top: 0;
        }

        &.stickyHidden {
            top: -250px;
            &,
            & > * {
                max-height: 0;
                overflow: hidden;
            }
        }

        &.editingMode {
            position: unset;
        }

        ${xScreen("lte", "md")} {
            display: none;
        }

        ${hideElementOnPrint}
    `,
};

viewStyles.headerPage = {
    css: css`
        &&&& {
            padding: 8px 16px;
        }
    `,
};

viewStyles.imageSection = {
    css: css`
        width: 508px;
        ${xScreen("lte", "lg")} {
            width: 430px;
        }
        ${xScreen("lte", "md")} {
            max-width: calc(100% - 378px);
            flex-grow: 1;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            max-width: unset;
        }
        & > div {
            display: flex;
            row-gap: 16px;
            flex-direction: column;
        }
    `,
};
viewStyles.actionsAndWarehouseWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        margin-bottom: 24px;
        ${xScreen("lte", "md")} {
            width: 358px;
            margin-bottom: 0;
        }
        ${xScreen("lte", 767)} {
            max-width: 100%;
        }
        & > div:empty {
            display: none;
        }
    `,
};

viewStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 44px;
    `,
};

viewStyles.topSection = {
    css: css`
        display: flex;
        column-gap: 22px;
        margin-bottom: 44px;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
            column-gap: 20px;
            row-gap: 24px;
            margin-bottom: 0;
        }
    `,
};

viewStyles.leftSection = {
    css: css`
        width: calc(100% - 398px);
        ${xScreen("lte", "lg")} {
            width: calc(100% - 339px);
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
viewStyles.rightSection = {
    css: css`
        width: 376px;
        ${xScreen("lte", "lg")} {
            width: 317px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
viewStyles.productInfo = {
    css: css`
        width: calc(100% - 530px);
        ${xScreen("lte", "lg")} {
            width: 452px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

viewStyles.actionsWrapper = {
    css: css``,
};
viewStyles.productNumbersWrapper = {
    css: css`
        display: flex;
        column-gap: 16px;
        flex-wrap: wrap;
        margin-bottom: 8px;
        align-items: center;
    `,
};

viewStyles.badgesZoneWrapper = {
    css: css`
        > div {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
        }
    `,
};

viewStyles.separator = {
    css: css`
        margin: 16px 0;
        width: 100%;
        height: 1px;
        border-top: 1px solid ${color("common.border")};
    `,
};
viewStyles.documentaionsAndPropsWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
            column-gap: 20px;
        }
        ${xScreen("lte", 767)} {
            flex-direction: column;
        }
    `,
};
